import Parser from "@ext/markdown/core/Parser/Parser";
import { isMarkdownText } from "@ext/markdown/elements/pasteMarkdown/logic/markdownDetection";

export { isMarkdownText };

import { Slice } from "@tiptap/pm/model";
import type { Transaction } from "@tiptap/pm/state";
import type { EditorView } from "@tiptap/pm/view";
import { handlePaste } from "prosemirror-tables";

export const insertSlice = (tr: Transaction, view: EditorView, slice: Slice) => {
	tr.replaceSelection(slice);
	tr.setMeta("paste", true);
	tr.setMeta("uiEvent", "paste");
	view.dispatch(tr);
};

const handlePasteMarkdown = async (view: EditorView, event: ClipboardEvent, slice: Slice) => {
	const text = event.clipboardData?.getData("text/plain");
	try {
		const parser = new Parser();
		const editTree = await parser.editParse(text);

		const slice = Slice.fromJSON(view.state.schema, editTree);
		insertSlice(view.state.tr, view, slice);
	} catch {
		handlePaste(view, null, slice);
	}
};

export default handlePasteMarkdown;
